module.exports = __webpack_public_path__ + "img/emoji_49.064b70ef.png";